// @ts-ignore
import { expandProperty } from 'inline-style-expand-shorthand';

// https://jsperf.com/array-indexof-vs-object-key-lookup2/12
var handledCssProps = {
  // 'font', Oops, is not supported by inline-style-expand-shorthand
  padding: true,
  margin: true,
  border: true,
  borderWidth: true,
  borderStyle: true,
  borderColor: true,
  borderTop: true,
  borderRight: true,
  borderBottom: true,
  borderLeft: true,
  borderRadius: true,
  background: true,
  outline: true
};
export var felaExpandCssShorthandsPlugin = function felaExpandCssShorthandsPlugin(styles) {
  return Object.keys(styles).reduce(function (acc, cssPropertyName) {
    var cssPropertyValue = styles[cssPropertyName];
    if (cssPropertyValue === null || typeof cssPropertyValue === 'undefined') {
      acc[cssPropertyName] = cssPropertyValue;
    } else if (handledCssProps[cssPropertyName]) {
      var expandedProps = expandProperty(cssPropertyName, cssPropertyValue);
      if (expandedProps) {
        Object.assign(acc, expandedProps);
        return acc;
      }
      acc[cssPropertyName] = cssPropertyValue;
    } else if (Array.isArray(cssPropertyValue)) {
      acc[cssPropertyName] = cssPropertyValue;
    } else if (typeof cssPropertyValue === 'object') {
      acc[cssPropertyName] = felaExpandCssShorthandsPlugin(cssPropertyValue);
    } else {
      acc[cssPropertyName] = cssPropertyValue;
    }
    return acc;
  }, {});
};
//# sourceMappingURL=felaExpandCssShorthandsPlugin.js.map
